import React from 'react';
import { CheckCircle, Zap } from 'lucide-react';
import { areasServicio } from '../mock';

const AreaElectrica = () => {
  const area = areasServicio.electrica;

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section py-24">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <div className="inline-block mb-6">
                <span className="px-4 py-2 bg-yellow-400/20 text-yellow-400 rounded-full text-sm font-semibold backdrop-blur-sm border border-yellow-400/30">
                  Servicios Especializados
                </span>
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold heading-font mb-6">
                {area.titulo}
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed">
                {area.descripcion}
              </p>
            </div>
            <div className="relative">
              <img
                src={area.imagen}
                alt={area.titulo}
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-br from-blue-500/20 to-yellow-500/20 rounded-2xl blur-3xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Servicios Detallados */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-4">
              Servicios que Ofrecemos
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Soluciones completas para todas tus necesidades eléctricas
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {area.servicios.map((servicio, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
              >
                <CheckCircle className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                <p className="text-gray-700 font-medium">{servicio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Proceso de Trabajo 
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-4">
              Nuestro Proceso
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              { num: '01', title: 'Evaluación', desc: 'Inspección y análisis de necesidades' },
              { num: '02', title: 'Propuesta', desc: 'Cotización detallada y plan de trabajo' },
              { num: '03', title: 'Ejecución', desc: 'Instalación con personal certificado' },
              { num: '04', title: 'Certificación', desc: 'Entrega con garantía y documentación SEC' }
            ].map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-white text-3xl font-bold heading-font flex items-center justify-center mx-auto mb-4">
                  {step.num}
                </div>
                <h3 className="text-xl font-bold heading-font mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>*/}

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-950 text-white">
        <div className="container mx-auto px-4 text-center">
          <Zap className="w-16 h-16 text-yellow-400 mx-auto mb-6" />
          <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-6">
            ¿Necesitas Servicios Eléctricos?
          </h2>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
            Contáctanos para una evaluación gratuita y cotización sin compromiso
          </p>
          <a href="/contacto">
            <button className="btn-primary text-lg px-8 py-4">
              Solicitar Cotización
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default AreaElectrica;